import { render, staticRenderFns } from "./PhoneRegisterDialog.vue?vue&type=template&id=5bb51054&"
import script from "./PhoneRegisterDialog.vue?vue&type=script&lang=js&"
export * from "./PhoneRegisterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports